import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { createRoot } from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { Toaster } from 'sonner';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import Login from './screens/Login';
import RegistrationForm from './screens/Registrationform/RegistrationForm';
import Lockscreen from './screens/Auth/Lockscreen';
import Forgotpassword from './screens/Auth/ForgotPassword';
import Page403 from './screens/Auth/Page403';
import Page500 from './screens/Auth/Page500';
import Page503 from './screens/Auth/Page503';
import Maintanance from './screens/Pages/Maintanance';
import LandingPage from './screens/Dashbord/landingPage';
import ProtectedRoutes from './protectedRoutes';
import AddUserForm from './screens/User/addUserForm';
import Page404 from './screens/Auth/Page404';
import * as serviceWorker from './serviceWorker';
// import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/scss/bootstrap.scss';
import './assets/assets/scss/main.scss';
import './assets/assets/scss/color_skins.scss';
import 'font-awesome/css/font-awesome.min.css';
import ViewAllUsers from './screens/User/ViewAllUser';
import ViewAllPatients from './screens/Dashbord/Patient/ViewAllPatients';
import ResetPassword from './screens/Auth/ResetPassword';
import UpdatePassword from './screens/Auth/UpdatePassword';
import EditUserForm from './screens/User/EditUserForm';
import ViewPatient from './screens/Dashbord/Patient/ViewPatient';

import ClinicalProcess from './screens/Dashbord/ClinicalManagement/ClinicalProcess';

import ClinicalManagementLanding from './screens/Dashbord/ClinicalManagement/ClinicalManagementLanding';
import Andrology from './screens/Dashbord/andrology';
import EmbryologyLanding from './screens/Dashbord/Embryology/EmbryologyLanding';
import Notifications from './screens/Notifications/Notifications';
import KpiLanding from './screens/kpi/KpiLanding';
const store = configureStore({ reducer: reducers, middleware: () => [thunk] });

const router = createBrowserRouter([
  {
    path: `${process.env.PUBLIC_URL}/`,
    element: (
      <ProtectedRoutes>
        <App />
      </ProtectedRoutes>
    ),
    children: [
      {
        path: '/',
        element: <LandingPage />,
      },
      {
        path: 'patient-form',
        element: <RegistrationForm />,
      },
      {
        path: 'add-user',
        element: <AddUserForm />,
      },
      {
        path: 'view-fet-patients',
        element: <ClinicalManagementLanding />,
      },

      {
        path: 'view-users',
        element: <ViewAllUsers />,
      },
      {
        path: 'edit-user/:id',
        element: <EditUserForm />,
      },
      {
        path: 'view-patients',
        element: <ViewAllPatients />,
      },
      {
        path: 'dynamic/:id',
        element: <Page404 />, // Default route to catch undefined routes
      },
      {
        path: '/patient/:id/view',
        element: <ViewPatient />,
      },
      {
        path: '/patient/:id/edit',
        element: <RegistrationForm />,
      },
      // {
      //   path: '/fms',
      //   element: <Fms />,
      // },
      {
        path: '/patient/:id/clinical-management',
        element: <ClinicalProcess />,
      },
      {
        path: '/andrology',
        element: <Andrology />,
      },
      {
        path: '/embrology',
        element: <EmbryologyLanding />,
      },
      {
        path: '/notifications',
        element: <Notifications />,
      },
      {
        path: '/kpi',
        element: <KpiLanding />,
      },
    ],
  },
  {
    path: `${process.env.PUBLIC_URL}/login`,
    element: <Login />,
  },
  {
    path: `${process.env.PUBLIC_URL}/forgotpassword`,
    element: <Forgotpassword />,
  },
  {
    path: `${process.env.PUBLIC_URL}/updatepassword`,
    element: <UpdatePassword />,
  },
  {
    path: `${process.env.PUBLIC_URL}/resetPassword`,
    element: <ResetPassword />,
  },
  {
    path: `${process.env.PUBLIC_URL}/lockscreen`,
    element: <Lockscreen />,
  },
  {
    path: `${process.env.PUBLIC_URL}/page404`,
    element: <Page404 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/page403`,
    element: <Page403 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/page500`,
    element: <Page500 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/page503`,
    element: <Page503 />,
  },
  {
    path: `${process.env.PUBLIC_URL}/maintanance`,
    element: <Maintanance />,
  },
  {
    path: `*`,
    element: <Page404 />, // Default route to catch undefined routes
  },
]);

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Toaster position="top-right" duration={3000} closeButton />
    <RouterProvider router={router} />
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
